const convertObjectToArray = (data = {}) => {
  return Object.entries(data);
};

export { convertObjectToArray };
